import { ref, computed, nextTick, inject } from "vue";

import { useStore } from "vuex";
import { useRoute } from "vue-router";

export default function (calendarRef, shiftsList, options) {
  const $store = useStore();
  // const $router = useRouter()
  const $route = useRoute();
  const $moment = inject(["$moment"]);

  const userRole = $store.getters.GET_USER_DATA.role;

  const shifts = shiftsList || ref([]);

  const bottomDropUp = ref({
    taken: [],
    notTaken: [],
  });

  const calendarDaySelected = ref(undefined);

  const dayShiftsList = ref({
    taken: [],
    notTaken: [],
  });

  const monthShiftsList = ref([]);
  const filledMonthShiftsList = ref({
    taken: [],
    notTaken: [],
  });

  const getCalendarStartEndDates = () => {
    if (calendarRef.value.getPageDays) {
      let calendarPage = calendarRef.value.getPageDays();
      return {
        calendarMonthStart: calendarPage[0].id,
        calendarMonthEnd: calendarPage[calendarPage.length - 1].id,
      };
    } else {
      let dayList = $(calendarRef.value.$el).find(".vc-day");
      return {
        calendarMonthStart: [...$(dayList[0])[0].classList]
          .find((x) => x.startsWith("id-"))
          .replace("id-", ""),
        calendarMonthEnd: [...$(dayList[dayList.length - 1])[0].classList]
          .find((x) => x.startsWith("id-"))
          .replace("id-", ""),
      };
    }
  };

  const fillCalendarMonth = (update) => {
    let calendarDates = getCalendarStartEndDates();
    let calendarMonthStart = calendarDates.calendarMonthStart;
    let calendarMonthEnd = calendarDates.calendarMonthEnd;

    if (!shiftsList || update) {
      (async () => {
        try {
          let shiftsRequest = {
            start_date: calendarMonthStart,
            end_date: calendarMonthEnd,
          };
          if (userRole === "pharmacy") {
            shiftsRequest.navigation = "pharmacy_calendar";
          } else if (options?.navigation) {
            shiftsRequest.navigation = options.navigation;
            shiftsRequest.per_page = 200;
          } else {
            shiftsRequest.with =
              "pharmacy,pharmacy.settings,pharmacy.address,locum,locum.settings,locum.preferred_name,locum.address,locum.address,abilities,pharmacy.files, pharmacy.preferred_name, agency, shiftApplications,job";
            shiftsRequest.per_page = 200;
          }
          let shiftList = await $store.dispatch(
            "GET_SHIFT_LIST",
            shiftsRequest
          );

          shifts.value = shiftList.data;

          setDisabledDates();
          if (options.setDaySelected !== false) {
            setCalendarDaySelected(options.setDaySelected);
          }
        } catch (error) {
          console.log(error);
        }
      })();
    } else {
      setDisabledDates();
      if (options.setDaySelected !== false) {
        setCalendarDaySelected(options.setDaySelected);
      }
    }
  };

  const setCalendarDaySelected = (date) => {
    if (date) {
      calendarDayClick({
        id: date,
      });
    } else {
      fillMonthShiftsList();
      const todayShifts = monthShiftsList.value.filter(
        (shift) => shift.date == $moment().format("YYYY-MM-DD")
      );

      if (
        calendarDaySelected.value == undefined &&
        monthShiftsList.value.length
      ) {
        if ($route.params.date != "null" && $route.params.date) {
          calendarDaySelected.value = $route.params.date;
        } else if (todayShifts.length) {
          calendarDaySelected.value = $moment().format("YYYY-MM-DD");
        } else {
          calendarDaySelected.value = monthShiftsList.value[0].date;
        }

        calendarDayClick({
          id: calendarDaySelected.value,
        });
      } else if (monthShiftsList.value.length) {
        calendarDayClick({
          id: todayShifts.length
            ? $moment().format("YYYY-MM-DD")
            : monthShiftsList.value[0].date,
        });
      } else {
        dayShiftsList.value.taken = [];
        dayShiftsList.value.notTaken = [];
      }
    }
  };

  const shiftDates = computed(() => {
    return shifts.value.map((day) => day.date);
  });

  const selectAttribute = {
    highlight: {
      class: "selected",
    },
  };

  const getShiftsRange = (type) => {
    if (shiftDates.value.length) {
      let dates = shiftDates.value.map((x) => new Date(x));
      if (type == "page") {
        return {
          minDate: {
            month: $moment(Math.min.apply(null, dates)).format("M"),
            year: $moment(Math.min.apply(null, dates)).format("YYYY"),
          },
          maxDate: {
            month: $moment(Math.max.apply(null, dates)).format("M"),
            year: $moment(Math.max.apply(null, dates)).format("YYYY"),
          },
        };
      } else
        return {
          minDate: new Date(Math.min.apply(null, dates)),
          maxDate: new Date(Math.max.apply(null, dates)),
        };
    }
    return {
      minDate: null,
      maxDate: null,
    };
  };

  const fromPage = ref(getShiftsRange("page").minDate);

  const calendarAttrs = computed(() => {
    let calendarAttrs = [];
    if (options.attrs) {
      options.attrs.forEach((attr) => {
        switch (attr) {
          case "status":
            shifts.value.forEach((shift) => {
              let attr = {
                highlight: {
                  class: shift.statusClass,
                },
                dates: shift.date,
                customData: {
                  class: shift.statusClass,
                },
              };
              if (
                shift.statusText == "assigned" ||
                shift.statusText == "disputed"
              ) {
                attr.dot = {
                  class: shift.statusText,
                };
              }
              calendarAttrs.push(attr);
            });
            break;
          case "today":
            calendarAttrs.push({
              // key: 'today',
              highlight: {
                class: "today",
              },
              dates: new Date(),
              customData: {
                class: "today",
              },
            });
            break;
          case "shiftsAsDots":
            shifts.value.forEach((shift) => {
              if (!calendarAttrs.find((x) => x.dates == shift.date)) {
                let attr = {
                  dates: shift.date,
                  customData: {
                    class: "with_dot",
                  },
                  dot: {
                    class: "assigned",
                  },
                };
                calendarAttrs.push(attr);
              }
            });
            break;
        }
        if (attr.selected) {
          const selected = {
            order: 1,
            highlight: {
              class: "selected",
              contentClass: "selected",
            },
            dates: attr.selected.value,
            customData: {
              class: "selected",
            },
          };
          calendarAttrs.push(selected);
        }

        if (attr.errors) {
          const errors = {
            order: 1,
            highlight: {
              class: "selected",
              contentClass: "selected",
            },
            dates: attr.errors.value,
            customData: {
              class: "error",
            },
          };
          calendarAttrs.push(errors);
        }
      });
    }

    return calendarAttrs;
  });

  const calendarMonthCount = computed(() => {
    if (
      $moment(getShiftsRange("date").minDate).format("MMMM") ==
      $moment(getShiftsRange("date").maxDate).format("MMMM")
    ) {
      return 1;
    } else return 2;
  });

  let disabledDates = ref([]);

  const setDisabledDates = () => {
    // let start = new Date(getShiftsRange().minDate);
    // let end = new Date(getShiftsRange().maxDate);

    if (calendarRef.value) {
      let calendarDates = getCalendarStartEndDates();
      let calendarMonthStart = calendarDates.calendarMonthStart;
      let calendarMonthEnd = calendarDates.calendarMonthEnd;
      let start = new Date($moment(calendarMonthStart, "YYYY-MM-DD"));
      let end = new Date($moment(calendarMonthEnd, "YYYY-MM-DD"));
      let loop = new Date(start.setDate(start.getDate() - 1));
      let disabledDatesArray = [];
      while (loop < end) {
        let newDate = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDate);
        let date = !shiftDates.value.some(
          (x) =>
            $moment(new Date(x)).format("YYYY/MM/DD") ===
            $moment(loop).format("YYYY/MM/DD")
        );
        if (date) disabledDatesArray.push($moment(loop).format("YYYY/MM/DD"));
      }
      disabledDates.value = disabledDatesArray;
      if (options.disabledDates) {
        disabledDates.value.concat(options.disabledDates.value);
      }
    }
  };

  const changePathParams = (day) => {
    if (options.changePathParams !== false) {
      const path = `${location.pathname.split("/calendar")[0]}/calendar/${day}`;
      history.replaceState({}, null, path);
    }
    // $router.replace({path: path})
  };

  const calendarDayClick = (day) => {
    calendarDaySelected.value = day.id;
    onCalendarSelect(day, changePathParams(day.id || day));
    scrollToDate(day.id || day);
    // fillDayShiftsList(day);
  };

  const onCalendarSelect = (day, daysList, callback) => {
    if (typeof day == "string") {
      $(".calendar_comp .vc-day.id-" + day).toggleClass("selected");
    } else if (!day) {
      fromPage.value = null;
      nextTick(() => {
        daysList.map((day) => {
          let dayEl = $(".calendar_comp .vc-day.id-" + day);
          if (dayEl.length && !dayEl.hasClass("selected")) {
            dayEl.addClass("selected");
          }
        });
      });
    } else if (!daysList) {
      $(".calendar_comp .vc-day.selected").removeClass("selected");
      $(".calendar_comp .vc-day.id-" + day.id).addClass("selected");
    } else {
      daysList.some((x, i) => {
        if (x.date == day.id) {
          $(day.el).parent().toggleClass("selected");
          if (typeof x.checkboxValue != "undefined") {
            x.checkboxValue = !x.checkboxValue;
          } else {
            daysList.splice(i, 1);
          }
          return true;
        }
      });
    }
    if (callback) {
      callback;
    }
  };

  const scrollToDate = (date) => {
    // $(document).ready(function () {
    // });
    $(".day_title.selected-bg").removeClass("selected-bg");
    $(`[data-date='${date}']`).addClass("selected-bg");
    if ($(".month_shift_list").length && $(`[data-date='${date}']`).length) {
      console.log("emulate mode", $(".emulateMode").length);
      if ($(".emulateMode").length) {
        $("html, body").animate(
          {
            scrollTop:
              $(`[data-date='${date}']`).offset().top -
              ($(".toolbar-title-default").length
                ? $(".toolbar-title-default").height() +
                  $(".emulateMode").height() +
                  30
                : 0),
          },
          "normal"
        );
      } else {
        $("html, body").animate(
          {
            scrollTop:
              $(`[data-date='${date}']`).offset().top -
              ($(".toolbar-title-default").length
                ? $(".toolbar-title-default").height()
                : 0),
          },
          "normal"
        );
      }
    }
  };

  const fillMonthShiftsList = () => {
    monthShiftsList.value = shifts.value.filter((shift) =>
      shift.date.includes(
        $moment(calendarRef.value.firstPage.key, "YYYY-M").format("YYYY-MM")
      )
    );

    filledMonthShiftsList.value.notTaken = [];

    bottomDropUp.value.taken = [];
    bottomDropUp.value.notTaken = [];

    filledMonthShiftsList.value.taken = monthShiftsList.value.filter(
      (shift) => {
        if (
          shift.statusText != "created" ||
          (userRole == "locum" &&
            shift.shiftApplicationData &&
            shift.shiftApplicationData.status !== 5)
        ) {
          bottomDropUp.value.taken.push(false);
          return true;
        } else {
          if (userRole == "pharmacy") {
            bottomDropUp.value.notTaken.push(false);
            filledMonthShiftsList.value.notTaken.push(shift);
          }
        }
      }
    );

    // }
  };

  return {
    shifts,
    calendarDaySelected,
    setCalendarDaySelected,
    bottomDropUp,
    dayShiftsList,
    filledMonthShiftsList,
    monthShiftsList,
    fillCalendarMonth,
    setDisabledDates,
    selectAttribute,
    getShiftsRange,
    calendarAttrs,
    calendarMonthCount,
    fromPage,
    disabledDates,
    calendarDayClick,
    onCalendarSelect,
    shiftDates,
  };
}
